module.exports = __webpack_public_path__ + "img/Left_four.8c18afac.svg";